// Port of api/fuel/app/classes/filter/search/lists/filters/query/ready.php
export default {
	name: 'list.ready',
	priority: 2,
	require: function(config, filter) { return true },
	run: function(config, filter, data, query) {
		query.where('l.list_ready', '=', 1)
	}
}
